import Vue from "vue";
import Router from "vue-router";

// import pageHome from './views/page-home.vue' // 首页
// import pageMemberManage from './views/page-member-manage' //会员管理页
// import pageOrderCare from './views/page-order-care' //订单关怀

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/redirection",
      name: "redirection",
      component: (resolve) => {
        require(["./views/redirection.vue"], resolve);
      },
    },
    {
      path: "/refresh",
      name: "refresh",
      component: (resolve) => {
        require(["./views/refresh.vue"], resolve);
      },
    },
    // {
    //   path: "*",
    //   redirect: '/home'
    // },
    {
      path: "/home",
      name: "home",
      component: (resolve) => {
        require(["./views/home/page_home.vue"], resolve);
      },
    },
    // 互动营销
    {
      path: "/interactive",
      name: "interactive",
      component: (resolve) => {
        require(["./views/interactive/index.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter", //积分授权页面
      name: "prizeCenter",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter2", //积分授权页面
      name: "prizeCenter2",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter2.vue"], resolve);
      },
    },
    {
      path: "/login",
      name: "home",
      component: (resolve) => {
        require(["./views/login/login.vue"], resolve);
      },
    },
    {
      path: "/manage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "focusShop" },
        },
        // {
        //   path: "share_polite",
        //   name: "share_polite",
        //   component: (resolve) => {
        //     require(["./views/manage/share_polite.vue"], resolve);
        //   },
        // },
        {
          path: "manage",
          redirect: { name: "focusShop" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "focusShop" },
            },
            {
              path: "focusShop",
              name: "focusShop",
              component: (resolve) => {
                require(["./views/manage/focusShop.vue"], resolve);
              },
            },
            {
              path: "share_polite",
              name: "share_polite",
              component: (resolve) => {
                require(["./views/manage/share_polite.vue"], resolve);
              },
            },
            {
              path: "focus_merchandise",
              name: "focus_merchandise",
              component: (resolve) => {
                require(["./views/manage/focus_merchandise.vue"], resolve);
              },
            },
            {
              path: "grouping",
              name: "grouping",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
          ],
        },
        // 标签管理
        {
          path: "labelManage",
          redirect: { name: "labelManage" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "labelManage" },
            },
            {
              path: "labelManage",
              name: "labelManage",
              component: (resolve) => {
                require(["./views/manage/label_manage.vue"], resolve);
              },
            },
            {
              path: "automatic_marking",
              name: "automatic_marking",
              component: (resolve) => {
                require(["./views/manage/automatic_marking.vue"], resolve);
              },
            },
          ],
        },
      ],
    },

    // 会员关怀
    {
      path: "/orderCare",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },

      children: [
        // 下单催付
        {
          path: "",
          redirect: { name: "expediting" },
        },
        {
          path: "orderCare",
          redirect: { name: "expediting" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "expediting" },
            },
            {
              path: "goodsOrderCare",
              name: "goodsOrderCare",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },

              meta: {
                isOfficial: true,
                officialType: 4,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#邮费#",
                ],
              },
            },
            {
              path: "expediting",
              name: "expediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 1,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#催付链接#",
                ],
              },
            },
            {
              path: "twiceExpediting",
              name: "twiceExpediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 1,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#催付链接#",
                ],
              },
            },
            {
              path: "presaleExpediting",
              name: "presaleExpediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 2, //查询官方模板所需ID
                smsLabel: [],
              },
            },
          ],
        },

        // 付款关怀
        {
          path: "payReminder",
          redirect: { name: "payReminder" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "payReminder",
              name: "payReminder",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 3,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                ],
              },
            },
          ],
        },
        // 物流提醒
        {
          path: "transreMind",
          redirect: { name: "transreMind" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "cancelMind",
              name: "cancelMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 9,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "sendreMind",
              name: "sendreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 10,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
            {
              path: "delayMind",
              name: "delayMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 11,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "delivereMind",
              name: "delivereMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 12,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "recvreMind",
              name: "recvreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 13,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "goodsBackMind",
              name: "goodsBackMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 14,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
          ],
        },
        // 回款关怀
        {
          path: "moneyBack",
          redirect: { name: "moneyBack" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "回款关怀",
              path: "moneyBack",
              name: "moneyBack",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 15,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
          ],
        },
        // 评价关怀
        {
          path: "comtCare",
          redirect: { name: "comtCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "自动催评",
              path: "autoEvaluation",
              name: "autoEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 5,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢",
              path: "thankEvaluation",
              name: "thankEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚",
              path: "poorEvaluation",
              name: "poorEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢（自营）",
              path: "thankEvaluationOfficial",
              name: "thankEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚（自营）",
              path: "poorEvaluationOfficial",
              name: "poorEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
          ],
        },
        // 退款关怀
        {
          path: "refunCare",
          redirect: { name: "refunCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "申请退款",
              path: "apply",
              name: "apply",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 16,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "同意退款",
              path: "agree",
              name: "agree",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 17,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "拒绝退款",
              path: "deny",
              name: "deny",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 18,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退款成功",
              path: "suces",
              name: "suces",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 19,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
        // 会员关怀
        {
          path: "memberCare",
          redirect: { name: "memberCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "入会关怀",
              path: "openCardRemind",
              name: "openCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 20,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "升级有礼",
              path: "upgradeGift",
              name: "upgradeGift",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 21,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "降级关怀",
              path: "degradeRemind",
              name: "degradeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 22,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退会挽回",
              path: "closeCardRemind",
              name: "closeCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 23,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "积分变更通知",
              path: "pointChangeRemind",
              name: "pointChangeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 24,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
        // 购物关怀
        {
          path: "shopCare",
          redirect: { name: "shopCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "智能凑单提醒",
              path: "smartRecommendRemind",
              name: "smartRecommendRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 25,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "购后入会提醒",
              path: "buyWithNoOpenCardRemind",
              name: "buyWithNoOpenCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 26,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "直播预售下单关怀",
              path: "shopLivePreSaleOrderRemind",
              name: "shopLivePreSaleOrderRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 27,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "直播下单关怀",
              path: "shopLiveOrderRemind",
              name: "shopLiveOrderRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 28,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
      ],
    },
    // 售后中心
    {
      path: "/serviceCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "manualurg" },
        },
        {
          path: "evaluate",
          redirect: { name: "manualurg" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "manualurg" },
            },
            {
              path: "manualurg",
              name: "manualurg",
              component: (resolve) => {
                require(["./views/serviceCenter/manualurg.vue"], resolve);
              },
            },
            {
              path: "manualReply",
              name: "manualReply",
              component: (resolve) => {
                require(["./views/serviceCenter/manualReply.vue"], resolve);
              },
            },
            {
              path: "autoassess",
              name: "autoassess",
              component: (resolve) => {
                require(["./views/serviceCenter/autoassess.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "refundCenter",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "manualRefund",
              name: "manualRefund",
              component: (resolve) => {
                require(["./views/serviceCenter/manualRefund.vue"], resolve);
              },
            },
            {
              path: "autoRefund",
              name: "autoRefund",
              component: (resolve) => {
                require(["./views/serviceCenter/autoRefund.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "shopWarning",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "commentWarning",
              name: "commentWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/commentWarning.vue"], resolve);
              },
            },
            {
              path: "refundWarning",
              name: "refundWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/refundWarning.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "asesAnalysis",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "allGoodsAssess",
              name: "allGoodsAssess",
              component: (resolve) => {
                require(["./views/serviceCenter/allGoodsAssess.vue"], resolve);
              },
            },
            {
              path: "goodsMonitor",
              name: "goodsMonitor",
              component: (resolve) => {
                require(["./views/serviceCenter/goodsMonitor.vue"], resolve);
              },
            },
            {
              path: "delMonitor",
              name: "delMonitor",
              component: (resolve) => {
                require(["./views/serviceCenter/delMonitor.vue"], resolve);
              },
            },
          ],
        },
      ],
    },

    //客户营销
    {
      path: "/marketing",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "groupingX" },
        },
        {
          path: "marketing",
          redirect: { name: "groupingX" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "grouping" },
            },
            {
              path: "grouping",
              name: "groupingX",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
            {
              path: "/peopleFilter",
              name: "peopleFilter",
              component: (resolve) => {
                require(["./components/people-filter"], resolve);
              },
            },
            {
              path: "member_grouping",
              name: "member_grouping",
              component: (resolve) => {
                require(["./views/manage/member_grouping.vue"], resolve);
              },
            },
            {
              path: "black_list",
              name: "black_list",
              component: (resolve) => {
                require(["./views/manage/black_list.vue"], resolve);
              },
            },
            {
              path: "order_sent",
              name: "order_sent",
              component: (resolve) => {
                // require(['./views/marketing/order_sent.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "订单发送",
                typeIndex: 5, // 5.表示订单发送
              },
            },
            {
              path: "sms_record",
              name: "sms_record",
              component: (resolve) => {
                require(["./views/manage/sms_record.vue"], resolve);
              },
            },
            {
              path: "accurate_market",
              name: "accurate_market",
              component: (resolve) => {
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "精准营销",
                typeIndex: 1, // 1.表示精准营销
              },
            },
            //订单发送引导
            {
              path: "order_send_guide",
              name: "order_send_guide",
              component: (resolve) => {
                require(["./views/manage/order_send_guide.vue"], resolve);
              },
            },
            {
              path: "intelligent_market",
              name: "intelligentMarket",
              component: (resolve) => {
                // 智能营销
                require(["./views/intelligentMarket/index.vue"], resolve);
              }
            },
            //高级发送-start
            {
              path: "sendHeight",
              name: "sendHeight",
              component: (resolve) => {
                //高级发送
                require(["./views/intelligentMarket/sendHeight.vue"], resolve);
              }
            },
            //高级发送-end
            {
              path: '/miDetal',
              name: 'miDetal',
              component: (resolve) => {
                require(['./views/intelligentMarket/Detail.vue'], resolve)
              }
            },
            {
              path: "member_send",
              name: "member_send",
              component: (resolve) => {
                // require(['./views/manage/member_send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "会员发送",
                typeIndex: 2, // 2.表示精准营销
              },
            },
            {
              path: "designated_send",
              name: "designated_send",
              component: (resolve) => {
                // require(['./views/manage/designated-send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "指定号码发送",
                typeIndex: 3, // 3.指定号码发送
              },
            },
            {
              path: "variables-send",
              name: "variables-send",
              component: (resolve) => {
                // require(['./views/manage/variables_send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "变量短信发送",
                typeIndex: 4, // 4.变量短信发送
              },
            },
            // {
            //   path: 'marketing-record',
            //   name: 'marketing-record',
            //   component: (resolve) => {
            //     require(['./views/manage/marketing_record.vue'], resolve)
            //   },
            // },
            // summary_analysis.vue
            {
              path: "summary-analysis",
              name: "summary-analysis",
              component: (resolve) => {
                require(["./views/manage/sms_marketing_effect.vue"], resolve);
              },
            },
            // 订单发送自营
            {
              path: "self_order_send",
              name: "self_order_send",
              component: (resolve) => {
                require(["./views/ordersend/index.vue"], resolve);
              },
            },
            // 预售订单发送pop
            {
              path: "pop_presell_order_send",
              name: "pop_presell_order_send",
              component: (resolve) => {
                require(["./views/presellsend/index.vue"], resolve);
              },
            },
            // 预售订单发送自营
            {
              path: "self_presell_order_send",
              name: "self_presell_order_send",
              component: (resolve) => {
                require(["./views/presellsupport/index.vue"], resolve);
              },
            },
          ],
        },
        // 自动化营销
        {
          path: "auto_marketing",
          redirect: { name: "商品复购" },
          component: (resolve) => {
            require(["./views/manage/autoMarket/index.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品复购",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "根据商品的消耗周期，在商品即将消耗完的时候发送提醒，引导复购",
                itemIndex: 1,
                taskType: 25,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
              },
            },
            {
              path: "first_purchase",
              name: "首购有礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺购买的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 2,
                isOfficial: true,
                officialType: '20',
                taskType: 15,
                smsLabel: [
                  "#买家昵称#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            },
            {
              path: "repurchase",
              name: "复购有礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "对再次进店购买的客户发送关怀，引导下次进店复购",
                itemIndex: 3,
                taskType: 16,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
              },
            },
            {
              path: "sleep_remind",
              name: "休眠提醒",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对长时间没有进店购买的客户发送短信关怀，唤醒客户记忆回店购买",
                itemIndex: 4,
                taskType: 17,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "fullmonthgift",
              name: "满月礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "在距离客户首次购买满30天的时候发送短信关怀，引导进店复购",
                itemIndex: 5,
                taskType: 18,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "hundred_day_gift",
              name: "百日礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "距离客户购买满100天的时候，发送一条关怀短信，引导进店复购",
                itemIndex: 6,
                taskType: 19,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "anniversary",
              name: "周年庆",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "距离客户购买满1年的时候,发送一条关怀短信，引导进店复购",
                itemIndex: 7,
                taskType: 20,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "memberbill",
              name: "会员账单",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送月度消费账单，引导进店复购享受优惠",
                itemIndex: 8,
                taskType: 21,
                smsLabel: [
                  "#买家昵称#",
                  " #会员等级#",
                  "#最近一次购买时间#",
                  "#距今多久未购买#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            }, 
            {
              path: "activity",
              name: "活动码",
              component: (resolve) => {
                require(["./views/manage/autoMarket/activity.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送上月账单，提醒买家进店享受优惠",
                itemIndex: 9,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#活动码#",
                ],
              },
            },
          ],
        },
        // 自动化营销 （官方） 
        {
          path: "auto_marketing_official",
          redirect: { name: "goods_repurchase" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "first_purchase_official",
              name: "first_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺成交的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 1,
              },
            },
            {
              path: "reminder_purchase_official",
              name: "reminder_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },
            {
              path: "call_customer_churn",
              name: "call_customer_churn",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "客户超过180天未成交，自动发送关怀，唤醒客户记忆进店购买",
                itemIndex: 3,
              },
            },
            {
              path: "interest_customer_conversion",
              name: "interest_customer_conversion",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "近期有加购或者关注但无成交的客户持续转化",
                itemIndex: 4,
              },
            },
            {
              path: "conversion_unpurchased_members",
              name: "conversion_unpurchased_members",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对开卡入会一定时间后未购买的客户进行主动营销，提升转化率",
                itemIndex: 5,
              },
            },
            {
              path: "auto_market_official_module",
              name: "auto_market_official_module",
              component: (resolve) => {
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },
            
          ],
        },
        {
          path: "auto_market_official_module",
          redirect: { name: "goods_repurchase" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "marketing_model",
              name: "marketing_model",
              component: (resolve) => {
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },
          ]
        },
        {
          path: "chat",
          redirect: { name: "chat_Marketing" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "chat_Marketing",
              name: "chat_Marketing",
              component: (resolve) => {
                require(["./views/manage/group_chart_market.vue"], resolve);
              },
            },
            {
              path: "exclusiveCustomersService",
              name: "exclusiveCustomersService",
              component: (resolve) => {
                require(["./views/manage/customersService.vue"], resolve);
              },
            },
          ]
        }
      ],
    },
    //数据分析
    {
      path: "/analysis",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "customerAnalysisSelfSupport" },
        },
        {
          path: 'customerAnalysisSelfSupport',
          redirect: { name: 'customerAnalysisSelfSupport' },
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'customerAnalysisSelfSupport' },
            },
            {
              path: "customerAnalysisSelfSupport",
              name: "customerAnalysisSelfSupport",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },
            {
              path: 'marketing_insight',
              name: 'marketing_insight',
              component: (resolve) => {
                require(['./views/analysis/marketing_insight.vue'], resolve)
              },
            },
          ]
        },
        // 评价分析
        {
          path: "comment",
          redirect: { name: "customer_portrait" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // 商品评价分析
            {
              path: "goods_comment_analysis",
              name: "goods_comment_analysis",
              component: (resolve) => {
                require(["./views/serviceCenter/allGoodsAssess.vue"], resolve);
              },
            },
            // 删除数据监控
            {
              path: "goods_del_comment_monitor",
              name: "goods_del_comment_monitor",
              component: (resolve) => {
                require(["./views/serviceCenter/delMonitor.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "customerAnalysis",
          redirect: { name: "customer_portrait" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // {
            //   path: 'customer_portrait',
            //   name: 'customer_portrait',
            //   component: (resolve) => {
            //     require(['./views/analysis/customer_portrait.vue'], resolve)
            //   },
            // },
            // {
            //   path: "people_level",
            //   name: "people_level",
            //   component: (resolve) => {
            //     require(["./views/analysis/people_level.vue"], resolve);
            //   },
            // },

            // 自营--客户画像
            {
              path: "customer_portrait",
              name: "customer_portrait",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },

            // 客户转换分析
            {
              path: "customer_transform_analysis",
              name: "customer_transform_analysis",
              component: (resolve) => {
                require(["./views/analysis/people_switch.vue"], resolve);
              },
            },
            // 客户资产分析
            {
              path: "customer_asset_analysis",
              name: "customer_asset_analysis",
              meta: {
                name: "客户资产分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_asset.vue"], resolve);
              },
            },
            // 客户消费分析
            {
              path: "customer_consumer_analysis",
              name: "customer_consumer_analysis",
              component: (resolve) => {
                require(["./views/analysis/consume_analysis.vue"], resolve);
              },
            },
            // 客户价值分析
            {
              path: "customer_value_analysis",
              name: "customer_value_analysis",
              meta: {
                name: "客户价值分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_worth.vue"], resolve);
              },
            },
            // 客户流失分析
            {
              path: "customer_lost_analysis",
              name: "customer_lost_analysis",
              meta: {
                name: "客户流失分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_drain.vue"], resolve);
              },
            },
            // 地域分布分析
            {
              path: "region_distribution_analysis",
              name: "region_distribution_analysis",
              component: (resolve) => {
                require(["./views/analysis/region_distribution_analysis.vue"], resolve);
              },
            },
            // 新老客分析
            {
              path: "newAndOld_analysis",
              name: "newAndOld_analysis",
              component: (resolve) => {
                require(["./views/analysis/newAndOld_analysis.vue"], resolve);
              },
            },
            // 历史会员购买分析
            {
              path: "history_member_analysis",
              name: "history_member_analysis",
              component: (resolve) => {
                require(["./views/analysis/history_member_analysis.vue"], resolve);
              },
            },
            // 历史新老客分析
            {
              path: "history_newAndOld_analysis",
              name: "history_newAndOld_analysis",
              component: (resolve) => {
                require(["./views/analysis/history_newAndOld_analysis.vue"], resolve);
              },
            },
            // 客单价区间分析
            {
              path: "customer_unitPrice_analysis",
              name: "customer_unitPrice_analysis",
              component: (resolve) => {
                require(["./views/analysis/customer_unitPrice_analysis.vue"], resolve);
              },
            },
            // 新客留存率分析
            {
              path: "new_keep_analysis",
              name: "new_keep_analysis",
              meta: {
                title: "新客留存率分析", 
              },
              component: (resolve) => {
                require(["./views/analysis/keep_analysis.vue"], resolve);
              },
            },
            // 老客留存率分析
            {
              path: "old_keep_analysis",
              name: "old_keep_analysis",
              meta: {
                title: "老客留存率分析", 
              },
              component: (resolve) => {
                require(["./views/analysis/keep_analysis.vue"], resolve);
              },
            },
            {
              path: "money_analysis",
              name: "money_analysis",
              component: (resolve) => {
                require(["./views/analysis/money_analysis.vue"], resolve);
              },
            },
            {
              path: "marketing_insight",
              name: "marketing_insight",
              component: (resolve) => {
                require(["./views/analysis/marketing_insight.vue"], resolve);
              },
            },
            {
              path: "regional_analysis",
              name: "regional_analysis",
              component: (resolve) => {
                require(["./views/analysis/regional_analysis.vue"], resolve);
              },
            },
            {
              path: "amount_analysis",
              name: "amount_analysis",
              component: (resolve) => {
                require(["./views/analysis/amount_analysis.vue"], resolve);
              },
            },
            {
              path: "monthly_report",
              name: "月度报表",
              component: (resolve) => {
                require(["./views/analysis/monthly_report.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "rfmAnalysis",
          redirect: { name: "RFM分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "RFM_standard_analysis",
              name: "RFM标准分析",
              component: (resolve) => {
                require([
                  "./views/analysis/RFM_standard_analysis.vue",
                ], resolve);
              },
            },
            {
              path: "RFM_custom_analysis",
              name: "RFM自定义分析",
              component: (resolve) => {
                require(["./views/analysis/RFM_custom_analysis.vue"], resolve);
              },
            },
            {
              path: 'RFM_custom_analysis_shop',
              name: 'RFM_custom_analysis_shop',
              component: (resolve) => {
                require(['./views/analysis/RFM_custom_analysis_shop.vue'], resolve)
              },
            },
          ],
        },
        {
          path: "goods",
          redirect: { name: "商品回购周期分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品复购周期分析",
              component: (resolve) => {
                require(["./views/analysis/goods_repurchase.vue"], resolve);
              },
            },
            {
              path: "goods_combine",
              name: "商品销售连带分析",
              component: (resolve) => {
                require(["./views/analysis/goods_combine.vue"], resolve);
              },
            },
            {
              path: "goods_analysis",
              name: "商品交易透视",
              component: (resolve) => {
                require(["./views/analysis/goods_analysis.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //后台管理
    {
      path: "/backstage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "sms_management" },
        },
        {
          path: "backstage",
          redirect: { name: "sms_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "sms_management" },
            },
            {
              path: "sms_management",
              name: "sms_management",
              component: (resolve) => {
                require(["./views/backstage/sms_management.vue"], resolve);
              },
            },
            {
              path: "sms_reply_record",
              name: "sms_reply_record",
              component: (resolve) => {
                require(["./views/backstage/sms_reply_record.vue"], resolve);
              },
            },
            {
              path: "sms_bill",
              name: "sms_bill",
              component: (resolve) => {
                require(["./views/backstage/sms_bill.vue"], resolve);
              },
            },
            {
              path: "sms_module",
              name: "smsModule",
              component: (resolve) => {
                require(["./views/backstage/sms_module.vue"], resolve);
              },
            },
          ],
        },
        //系统设置
        {
          path: "account",
          redirect: { name: "account" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "account" },
            },
            {
              path: "account",
              name: "account",
              component: (resolve) => {
                require(["./views/backstage/account_settings.vue"], resolve);
              },
            },
            {
              path: "store_binding",
              name: "store_binding",
              component: (resolve) => {
                require(["./views/backstage/store_binding.vue"], resolve);
              },
            },
          ],
        },
        //签名报备
        {
          path: "signature_management",
          redirect: { name: "signature_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "signature_management" },
            },
            {
              path: "signature_management",
              name: "signature_management",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_management.vue",
                ], resolve);
              },
            },
            {
              path: "signature_report_official",
              name: "signature_report_official",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_report_official.vue",
                ], resolve);
              },
            },
          ],
        },
        //签名设置
        // {
        //   name: 'signature_set',
        //   path: 'signature_set',
        //   component: (resolve) => {
        //     require(['./views/backstage/signature_set.vue'], resolve)
        //   }
        // },
        //帮助中心
        // {
        //   path: 'online_service',
        //   name: 'online_service',
        //   component: (resolve) => {
        //     require(['./views/backstage/online_service.vue'], resolve)
        //   }
        // },
        // 富信资质
        {
          name: "media_qualification",
          path: "media_qualification",
          component: (resolve) => {
            require(["./views/backstage/mediaQualification/index.vue"], resolve);
          },
        },
        // 增值服务
        {
          name: "valueAddService",
          path: "valueAddService",
          component: (resolve) => {
            require(["./views/backstage/valueAddService/index.vue"], resolve);
          },
        },
        // 导出管理
        {
          name: "export_management",
          path: "export_management",
          component: (resolve) => {
            require(["./views/backstage/exportManagement/index.vue"], resolve);
          },
        },

        //邀请好友赚积分
        {
          name: "invite_friends",
          path: "invite_friends",
          component: (resolve) => {
            require(["./views/backstage/invite_friends.vue"], resolve);
          },
        },
      ],
    },
    //积分中心
    {
      path: "/integralCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "mutualMember" },
        },
        {
          path: "integralCenter",
          redirect: { name: "mutualMember" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "mutualMember" },
            },
            {
              path: "mutualMember",
              name: "mutualMember",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/mutualMember.vue",
                ], resolve);
              },
            },
            {
              path: "memberLevel",
              name: "memberLevel",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberLevel.vue",
                ], resolve);
              },
            },
            {
              path: "memberPower",
              name: "memberPower",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberPower.vue",
                ], resolve);
              },
            },
          ],
        },
        {
          path: "integralTask",
          name: "integralTask",
          component: (resolve) => {
            require(["./views/integralCenter/integralTask.vue"], resolve);
            // require(['./views/integralCenter/memberCenter/mutualMember.vue'], resolve)
          },
        },
        {
          path: "integralEden",
          name: "integralEden",
          component: (resolve) => {
            require(["./views/integralCenter/integralEden.vue"], resolve);
          },
        },
        {
          path: "shopDecoration",
          name: "shopDecoration",
          component: (resolve) => {
            require(["./views/integralCenter/shopDecoration.vue"], resolve);
          },
        },
        {
          path: "integralMall",
          name: "integralMall",
          component: (resolve) => {
            require(["./views/integralCenter/integralMall.vue"], resolve);
          },
        },
        //奖品中心
        {
          path: 'prizeCenter',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'prizeCenter' }
            },
            {
              path: 'coupon_management',
              name: 'coupon_management',
              component: (resolve) => {
                require(['./views/integralCenter/coupon_management.vue'], resolve)
              }
            }, {
              path: 'asset_management',
              name: 'asset_management',
              component: (resolve) => {
                require(['./views/integralCenter/asset_management.vue'], resolve)
              }
            }
          ]
        },
        {
          path: "dataAnalysis",
          // redirect:{ name:'dataAnalysis' },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "dataAnalysis" },
            },
            {
              path: "flow_analysis",
              name: "flow_analysis",
              component: (resolve) => {
                require(["./views/integral/flow_analysis.vue"], resolve);
              },
            },
            {
              path: "prize_statistics",
              name: "prize_statistics",
              component: (resolve) => {
                require(["./views/integral/prize_statistics.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //店铺装修
    {
      path: "/draw",
      component: (resolve) => {
        require(["./views/integralCenter/draw/draw.vue"], resolve)
      },
    },

    // 行业专区
    // 行业运营策略
    {
      path: '/industryStrategy',
      name: 'industryStrategy',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/strategy'], resolve)
      }
    },
    // 行业破圈
    {
      path: '/industrySolution',
      name: 'industrySolution',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/breakCircle'], resolve)
      }
    },
    // 行业人群
    {
      path: '/industryCrowd',
      name: 'industryCrowd',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/crowd'], resolve)
      }
    },
    // 行业专区京获客引导页
    {
      path:'/jhkGuide',
      name: 'jhkGuide',
      component: (resolve) => {
        require(['./views/industry/jhkGuide'], resolve)
      }
    },
    // 行业专区预览页
    {
      path:'/industryPreview',
      name: 'industryPreview',
      component: (resolve) => {
        require(['./views/industry/preview'], resolve)
      }
    },
    // 高级功能列表开发
    // {
    //   path: 'show_advanced_version',
    //   name: 'show_advanced_version',
    //   component: (resolve) => {
    //     require(["./views/advancedVersion.vue"], resolve);
    //   },
    //   meta: {
    //     typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
    //   }
    // },
    {
      path: '/*/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    // 订单关怀
    {
      path: '/*/*/*_preview',
      name: 'orderCare_preview',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 4, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_preview',
      name: 'orderCare_preview',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 4, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    
  ],
});
